import { createFileRoute } from "@tanstack/react-router";
import { EmailStatus } from "../app/views/emailStatus/emailStatus";

export const Route = createFileRoute("/email")({
  component: EmailStatus,
});
